export { default } from './getThemeProps';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/getThemeProps/index.js
// module id = 576
// module chunks = 2